import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@mafc/trolly';
import COLORS from 'theme/colors';
import { CardType } from 'network/response/ICart';
import CardDivider from 'pages/Checkout/components/CheckoutOrderSummary/snippets/CardDivider';
import { IOrderConfirmationPaymentInfo } from 'pages/OrderConfirmation/OrderConfirmation.types';
import { MasterCard, VisaCard, CardPaymentNew } from '@mafc/icon';
import { ReactComponent as CodIcon } from 'assets/svgs/icon-cod-cart-checkout.svg';
import { ReactComponent as CardOnDeliveryIcon } from 'assets/svgs/icon-card-on-delivery-cart-checkout.svg';
import EPaymentMethods from 'pages/Checkout/components/Payment/PamentMethods.enum';
import OrderSummaryRow from 'common/OrderSummary/components/OrderSummaryRow';
import useApigeeLabels from 'common/ApigeeLabels/hooks/useApigeeLabels';
import SummaryRowTypes from 'common/OrderSummary/components/OrderSummaryRow/row.types';
import { IFinalPrice } from 'utils/price.util';

const PaymentOrderSummary: React.FC<{
  paymentInfo: IOrderConfirmationPaymentInfo;
  totalPriceWithTax?: IFinalPrice;
}> = ({ paymentInfo, totalPriceWithTax }) => {
  const { t } = useTranslation();
  const { paymentMethods } = useApigeeLabels();

  const { cardNumber = '', cardType: { code = '' } = {} } = paymentInfo;

  const codeInLower = code.toLowerCase();
  const cardOnDeliveryInLower = code.toLowerCase();

  const isPaymentExists =
    Object.keys(paymentInfo).length > 0 && codeInLower !== EPaymentMethods.CASHBACK;

  let Icon;
  let iconSize = 'M';
  let message = cardNumber || t('orderConfirmation.card');
  if (codeInLower === EPaymentMethods.COD) {
    Icon = CodIcon;
    message = t('orderConfirmation.cashOnDelivery');
  } else if (code && cardNumber) {
    if (codeInLower === CardType.master) {
      Icon = MasterCard;
    } else {
      Icon = VisaCard;
    }
  } else if (cardOnDeliveryInLower === EPaymentMethods.CARD_ON_DELIVERY) {
    Icon = CardOnDeliveryIcon;
    message = t('cardOnDeliveryText');
  } else {
    Icon = CardPaymentNew;
    iconSize = 'CUSTOM';
  }

  return isPaymentExists ? (
    <>
      <Box mb={12}>
        <OrderSummaryRow label={paymentMethods} variant={SummaryRowTypes.header} />

        <OrderSummaryRow
          label={
            <Box display="flex" alignItems="center">
              <Icon testid={code} size={iconSize} width="30" height="26" />
              <Box ml={1} fontSize={1} color={COLORS.BLACK}>
                {message}
              </Box>
            </Box>
          }
          priceDetails={totalPriceWithTax}
        />
      </Box>
      <CardDivider mb="12px" width={1} bg={COLORS.MERCURY} />
    </>
  ) : (
    <></>
  );
};

export default PaymentOrderSummary;
